import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from '@firebase/util';
import { tap } from 'rxjs';
import { NgrxService } from 'src/app/services';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CohortService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadCourseApi(courseId: any) {
		return this.ngrxService.loadInitAPI('cohorts', 'course', courseId);
	}

	loadCourseData(courseId: any) {
		return this.getCohortList(courseId).pipe(
			tap(data =>
				this.ngrxService.loadInitData('cohorts', 'course', courseId, data),
			),
		);
	}

	fetchCourseData(courseId: any) {
		return this.ngrxService.loadData('cohorts', 'course', courseId);
	}

	getCohortList(courseId: any) {
		return this.http.get(
			environment.url.cohort + `/course/${courseId}/cohorts`,
		);
	}
}
